import { Alert, Snackbar } from "@mui/material";
import React from "react";
import useAppContext from "../context/AppContext";

export default function AppSnackbar() {
  //   console.log("AppSnackbar");
  const { snackbar, setSnackbar } = useAppContext();

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={snackbar.duration || 3000}
      onClose={() => setSnackbar({ open: false })}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      // Centred and capped so it never spans a desktop viewport; lifted above
      // the bottom tab bar on phones (src/index.css --mhv-nav-h).
      sx={{
        width: "calc(100% - 16px)",
        maxWidth: 480,
        "@media (max-width: 767.98px)": {
          bottom: "calc(var(--mhv-nav-h) + 8px)",
        },
      }}
    >
      <Alert
        onClose={() => setSnackbar({ open: false })}
        severity={snackbar.severity}
        sx={{ width: "100%" }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
